import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ComponentsModule } from '@freelancer/components';
import { PipesModule } from '@freelancer/pipes';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { TaskListsModule } from 'app/task-lists/task-lists.module';
import { ProjectLocationDetailsModule } from '../../../project-view-details/project-location-details/project-location-details.module';
import { ConfirmPickupDeliveryModalModule } from './confirm-pickup-delivery-modal/confirm-pickup-delivery-modal.module';
import { FreightlancerLoadViewTrackingWrapperComponent } from './freightlancer-load-view-tracking-wrapper.component';
import { FreightlancerLoadViewTrackingComponent } from './freightlancer-load-view-tracking.component';
import { LoadTrackingButtonsComponent } from './load-tracking-buttons/load-tracking-buttons.component';
import { LoadTrackingSidebarComponent } from './load-tracking-sidebar/load-tracking-sidebar.component';
import { TrackingPickupDeliveryDetailsComponent } from './tracking-pickup-delivery-details/tracking-pickup-delivery-details.component';

@NgModule({
  imports: [
    UiModule,
    CommonModule,
    TaskListsModule,
    ComponentsModule,
    PipesModule,
    TrackingModule,
    ProjectLocationDetailsModule,
    ConfirmPickupDeliveryModalModule,
  ],
  declarations: [
    TrackingPickupDeliveryDetailsComponent,
    FreightlancerLoadViewTrackingWrapperComponent,
    FreightlancerLoadViewTrackingComponent,
    LoadTrackingSidebarComponent,
    LoadTrackingButtonsComponent,
  ],
  exports: [FreightlancerLoadViewTrackingWrapperComponent],
})
export class FreightlancerLoadViewTrackingModule {}
